module.exports = __webpack_public_path__ + "2acb60f2/img/search-filter-icon.c4751a52.svg";